import { DateTime } from "luxon";

import { AppointmentNotification } from "@/types/call.types";
import { IncidentReviewingNotification } from "@/types/incident.types";

export type StoredAppointmentNotification = Omit<AppointmentNotification, "receivedAt"> & {
    receivedAt: string;
};

export type StoredIncidentNotification = Omit<IncidentReviewingNotification, "receivedAt"> & {
    receivedAt: string;
};

export const toStoredAppointment = (notification: AppointmentNotification): StoredAppointmentNotification => ({
    ...notification,
    receivedAt: notification.receivedAt.toISO() ?? DateTime.now().toISO()!,
});

export const fromStoredAppointment = (notification: StoredAppointmentNotification): AppointmentNotification => ({
    ...notification,
    receivedAt: DateTime.fromISO(notification.receivedAt),
});

export const toStoredIncident = (notification: IncidentReviewingNotification): StoredIncidentNotification => ({
    ...notification,
    receivedAt: notification.receivedAt.toISO() ?? DateTime.now().toISO()!,
});

export const fromStoredIncident = (notification: StoredIncidentNotification): IncidentReviewingNotification => ({
    ...notification,
    receivedAt: DateTime.fromISO(notification.receivedAt),
});

export const serializeAppointments = (notifications: AppointmentNotification[]): StoredAppointmentNotification[] =>
    notifications.map(toStoredAppointment);

export const deserializeAppointments = (notifications: StoredAppointmentNotification[]): AppointmentNotification[] =>
    notifications.map(fromStoredAppointment);

export const serializeIncidents = (notifications: IncidentReviewingNotification[]): StoredIncidentNotification[] =>
    notifications.map(toStoredIncident);

export const deserializeIncidents = (notifications: StoredIncidentNotification[]): IncidentReviewingNotification[] =>
    notifications.map(fromStoredIncident);
